import {
  SET_CURRENT_USER,
  USER_LOADING,
  RESET_ALL,
  GET_USER_PROFILE,
  GET_MY_DEPT_INFO,
  VALIDATE_RESET_LINK,
} from "../config/actionTypes";
import isEmpty from "is-empty";

const initialState = {
  isAuthenticated: false,
  user: {},
  loading: false,
  profile: null,
  deptInfo: null,
  isResetLinkValid: false,
  emailToReset: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VALIDATE_RESET_LINK:
      return {
        ...state,
        isResetLinkValid: true,
        emailToReset: payload,
      };
    case GET_MY_DEPT_INFO:
      return {
        ...state,
        deptInfo: payload,
      };
    case GET_USER_PROFILE:
      return {
        ...state,
        profile: payload,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(payload),
        user: payload,
      };

    case RESET_ALL:
      return initialState;
    default:
      return state;
  }
}
